// extracted by mini-css-extract-plugin
export default {"paddings":"Companies_paddings__Z-Kn9","innerWidth":"Companies_innerWidth__4rgSJ","flexCenter":"Companies_flexCenter__5o64s","container":"Companies_container__3KxtP"};